import { Page } from '../types';
import { Icon } from './Icon';

const tabs: { id: Page; label: string; icon: string }[] = [
  { id: 'overview', label: 'Home', icon: 'grid' },
  { id: 'workout', label: 'Log', icon: 'plus' },
  { id: 'today-routine', label: 'Routine', icon: 'calendar' },
  { id: 'progress', label: 'Progress', icon: 'chart' },
  { id: 'weight', label: 'Weight', icon: 'scale' },
  { id: 'account', label: 'Account', icon: 'user' }
];

export function MobileTabBar({ page, onNavigate }: { page: Page; onNavigate: (page: Page) => void }) {
  return <nav className="mobile-tab-bar" aria-label="Primary navigation">{tabs.map(tab => <button key={tab.id} className={page === tab.id ? 'active' : ''} onClick={() => onNavigate(tab.id)} aria-current={page === tab.id ? 'page' : undefined}><Icon name={tab.icon}/><span>{tab.label}</span></button>)}</nav>;
}
